import {
  login, logout, orgLogin, orgRegister, confirmVerfiy, listDocumentType, adminLogin
  // , getInfo
} from '@/api/user'
import { getToken, setToken, removeToken, getUserId, setUserId, removeUserId } from '@/utils/auth'
import { resetRouter } from '@/router'
import sha1 from 'crypto-js/sha1'

const state = {
  token: getToken(),
  first_name: '',
  last_name: '',
  user_id: getUserId(),
  avatar: '',
  documentTypes: []
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_FIRST_NAME: (state, first_name) => {
    state.first_name = first_name
  },
  SET_LAST_NAME: (state, last_name) => {
    state.last_name = last_name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_USER_ID: (state, userId) => {
    state.user_id = userId
  },
  SET_DOCUMENT_TYPES: (state, documentTypes) => {
    state.documentTypes = documentTypes ? documentTypes.slice() : []
  }
}

const actions = {
  // user login
  login ({ commit }, userInfo) {
    // console.log('userInfo', userInfo)
    const { username, password } = userInfo
    return new Promise((resolve, reject) => {
      login({ username: username.trim(), password: sha1(password.trim()).toString() }).then(response => {
        console.log('login response', response)
        const { data } = response
        data.id = parseInt(data.id)
        commit('SET_TOKEN', data.token)
        commit('SET_USER_ID', data.id)
        setToken(data.token)
        setUserId(data.id)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  confirmVerfiy ({ commit }, data) {
    // console.log('orgLogin data', data)
    const {
      code
    } = data
    return new Promise((resolve, reject) => {
      confirmVerfiy({
        code: code
      }).then(response => {
        console.log('confirmVerfiy response', response)
        const { data } = response
        data.id = parseInt(data.id)
        commit('SET_TOKEN', data.token)
        commit('SET_USER_ID', parseInt(data.id))
        setToken(data.token)
        setUserId(data.id)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  orgLogin ({ commit }, data) {
    // console.log('orgLogin data', data)
    const {
      email,
      phone,
      password
    } = data
    let username
    if (phone) {
      username = phone
    } else if (email) {
      username = email
    }
    // console.log('username', username)
    // console.log('password', password)
    return new Promise((resolve, reject) => {
      orgLogin({
        username: username,
        password: sha1(password.trim()).toString()
      }).then(response => {
        // console.log('orgLogin response', response)
        const { data } = response
        data.id = parseInt(data.id)
        commit('SET_TOKEN', data.token)
        commit('SET_USER_ID', parseInt(data.id))
        setToken(data.token)
        setUserId(data.id)
        resolve()
      }).catch(error => {
        reject(error)
        // alert('Login failed. Please contact JobTotal Administrator.')
      })
    })
  },
  orgRegister ({ commit }, data) {
    // console.log('orgRegister data', data)
    const {
      email,
      first_name,
      last_name,
      organization_name,
      phone,
      password,
      locale,
      recommanded,
      promotion,
      searching
    } = data
    return new Promise((resolve, reject) => {
      orgRegister({
        email: email.trim(),
        first_name: first_name.trim(),
        last_name: last_name.trim(),
        organization_name: organization_name.trim(),
        phone: phone.trim(),
        password: sha1(password.trim()).toString(),
        locale: locale.trim(),
        recommanded: recommanded,
        promotion: promotion,
        searching: searching
      }).then(response => {
        console.log('login response', response)
        const { data } = response
        data.id = parseInt(data.id)
        commit('SET_TOKEN', data.token)
        commit('SET_USER_ID', parseInt(data.id))
        setToken(data.token)
        setUserId(data.id)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // get user info
  // getInfo ({ commit, state }) {
  //   return new Promise((resolve, reject) => {
  //     getInfo(state.token).then(response => {
  //       console.log('getInfo response', response)
  //       const { data } = response

  //       if (!data) {
  //         reject(new Error('Verification failed, please Login again.'))
  //       }

  //       const { name, avatar } = data

  //       commit('SET_NAME', name)
  //       commit('SET_AVATAR', avatar)
  //       resolve(data)
  //     }).catch(error => {
  //       reject(error)
  //     })
  //   })
  // },

  // user logout
  logout ({ commit, state }) {
    return new Promise((resolve, reject) => {
      logout(state.token).then(() => {
        commit('SET_TOKEN', '')
        commit('SET_USER_ID', 0)
        removeToken()
        removeUserId()
        resetRouter()
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // remove token
  resetToken ({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      commit('SET_USER_ID', 0)
      removeToken()
      removeUserId()
      resolve()
    })
  },
  listDocumentType ({ commit }) {
    return new Promise((resolve, reject) => {
      listDocumentType().then(response => {
        const items = response.data.items
        commit('SET_DOCUMENT_TYPES', items)
        resolve(items)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  adminLogin ({ commit }, data) {
    // console.log('orgLogin data', data)
    const {
      phone,
      password
    } = data
    let username
    if (phone) {
      username = phone
    }
    // console.log('username', username)
    // console.log('password', password)
    return new Promise((resolve, reject) => {
      adminLogin({
        username: username,
        password: sha1(password.trim()).toString(),
        client_name: 'web',
        client_os: 'web'
      }).then(response => {
        console.log('orgLogin response', response)
        const { data } = response
        data.id = parseInt(data.id)
        commit('SET_TOKEN', data.token)
        commit('SET_USER_ID', parseInt(data.id))
        setToken(data.token)
        setUserId(data.id)
        resolve()
      }).catch(error => {
        reject(error)
        // alert('Login failed. Please contact JobTotal Administrator.')
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
